let fileChecksumModule = null
async function getFileChecksum() {
  if (!fileChecksumModule) {
    fileChecksumModule = await import('activestorage/src/file_checksum')
  }
  return fileChecksumModule.FileChecksum
}

let blobUploadModule = null
async function getBlobUpload() {
  if (!blobUploadModule) {
    blobUploadModule = await import('activestorage/src/blob_upload')
  }
  return blobUploadModule.BlobUpload
}

export function calculateChecksum(file) {
  return getFileChecksum().then((FileChecksum) =>
    new Promise((resolve, reject) => {
      FileChecksum.create(file, (error, checksum) => {
        if (error) {
          reject(error)
        } else {
          resolve(checksum)
        }
      })
    })
  )
}

export async function getFileMetadata(file) {
  const checksum = await calculateChecksum(file)
  return ({
    checksum,
    filename: file.name,
    content_type: file.type || 'image/png',
    byte_size: file.size,
    metadata: {},
  })
}

export async function uploadToDirectUrl(url, headers, file) {
  const BlobUpload = await getBlobUpload()
  return new Promise((resolve, reject) => {
    const upload = new BlobUpload({ file, directUploadData: { url, headers } })
    upload.create((error) => {
      if (error) {
        reject(error)
      } else {
        resolve()
      }
    })
  })
}
